import { useCallback } from "react";
import { baseAxios } from "../apis";
import { useCsrfToken } from "./useCsrfToken";

const useAuthedApi = () => {
  const { fetchCsrfToken } = useCsrfToken();

  // GET is a "safe" HTTP method — Django's CSRF middleware doesn't check
  // it, so no token is needed. Kept here anyway so callers get one
  // consistent hook for every request instead of reaching for baseAxios
  // directly in components.
  const authedGet = useCallback(
    async (url, config = {}) => baseAxios.get(url, config),
    []
  );

  const authedPost = useCallback(
    async (url, payload = {}, config = {}) => {
      const token = await fetchCsrfToken();
      return baseAxios.post(url, payload, {
        ...config,
        headers: {
          ...config.headers,
          "X-CSRFToken": token,
        },
      });
    },
    [fetchCsrfToken]
  );

  const authedDelete = useCallback(
    async (url, config = {}) => {
      const token = await fetchCsrfToken();
      return baseAxios.delete(url, {
        ...config,
        headers: {
          ...config.headers,
          "X-CSRFToken": token,
        },
      });
    },
    [fetchCsrfToken]
  );

  const authedPatch = useCallback(
    async (url, payload, config = {}) => {
      const token = await fetchCsrfToken();
      return baseAxios.patch(url, payload, {
        ...config,
        headers: {
          ...config.headers,
          "X-CSRFToken": token,
        },
      });
    },
    [fetchCsrfToken]
  );

  return { authedGet, authedPost, authedDelete, authedPatch };
};

export default useAuthedApi;
